import { FaBriefcase, FaCalendarDays, FaChartLine, FaCodeBranch, FaComment, FaHandHoldingHeart, FaHouse, FaUserGraduate, FaUsers } from "react-icons/fa6"
import { Link } from "react-router-dom"


const AdminMenuOptions = ({isActivePath}) => {
  return (
   <>
     <Link
                    to="/admin/dashboard"
                    className={`opcion flex text-sm 2xl:text-base ${
                      isActivePath("/admin/dashboard") ? "activo" : "negro"
                    }`}
                  >
                    <FaHouse className="text-base 2xl:text-xl" />
                    INICIO
                  </Link>

                  <Link
                    to="/admin/usuarios"
                    className={`opcion flex text-sm 2xl:text-base ${
                      isActivePath("/admin/usuarios") ? "activo" : "negro"
                    }`}
                  >
                    <FaUsers className="text-base 2xl:text-xl" />
                    USUARIOS
                  </Link>

                  <Link
                    to="/admin/agenda"
                    className={`opcion flex text-sm 2xl:text-base ${
                      isActivePath("/admin/agenda") ? "activo" : "negro"
                    }`}
                  >
                    <FaCalendarDays  className="text-base 2xl:text-xl"/>
                    AGENDA
                  </Link>

                  <Link
                    to="/admin/empleo"
                    className={`opcion flex text-sm 2xl:text-base ${
                      isActivePath("/admin/empleo") ? "activo" : "negro"
                    }`}
                  >
                    <FaBriefcase className="text-base 2xl:text-xl" />
                    EMPLEO
                  </Link>

                  <Link
                    to="/admin/formacion"
                    className={`opcion flex text-sm 2xl:text-base ${
                      isActivePath("/admin/formacion") ? "activo" : "negro"
                    }`}
                  >
                    <FaUserGraduate className="text-base 2xl:text-xl" />
                    FORMACIÓN
                  </Link>

                  <Link
                    to="/admin/social"
                    className={`opcion flex text-sm 2xl:text-base ${
                      isActivePath("/admin/social") ? "activo" : "negro"
                    }`}
                  >
                    <FaHandHoldingHeart  className="text-base 2xl:text-xl"/>
                    SOCIAL
                  </Link>

                  <Link
                    to="/admin/recursos"
                    className={`opcion flex text-sm 2xl:text-base ${
                      isActivePath("/admin/recursos") ? "activo" : "negro"
                    }`}
                  >
                    <FaCodeBranch className="text-base 2xl:text-xl"/>
                    RECURSOS
                  </Link>

                  <Link
                    to="/admin/estadisticas"
                    className={`opcion flex text-sm 2xl:text-base ${
                      isActivePath("/admin/estadisticas") ? "activo" : "negro"
                    }`}
                  >
                    <FaChartLine  className="text-base 2xl:text-xl"/>
                    ESTADÍSTICAS
                  </Link>

                  <Link
                    to="/admin/chat"
                    className={`opcion flex text-sm 2xl:text-base ${
                      isActivePath("/admin/chat") ? "activo" : "negro"
                    }`}
                  >
                    <FaComment  className="text-base 2xl:text-xl"/>
                    CHAT
                  </Link>
   </>
  )
}

export default AdminMenuOptions